// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU4_thecomp__NqYfN"};